<template>
  <el-select
    v-model="input"
    :remote-method="querySearch"
    placeholder="Enter name of Rate Card"
    multiple
    filterable
    remote
    class="w-100"
    size="small"
    clearable
    :disabled="disabled"
    :loading="isLoading"
    @clear="clearInput"
  >
    <el-option
      v-for="item in data"
      :key="item.id"
      :label="formatName(item)"
      :value="item.id"
    />
  </el-select>
</template>

<script>
export default {
  name: 'RateCardAutoComplete',
  props: {
    value: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      input: '',
      data: [],
      isLoading: false
    }
  },
  created () {
    if (this.value.id) {
      this.input = this.value.name
    }
  },
  methods: {
    formatName (item) {
      const name = item.name
      const type = item.type.toUpperCase() || 'unknown'
      const carrier = item.carrier ? item.carrier.name : ''
      const active = item.active ? 'Active' : 'Inactive'
      const endDate = item.date_end ? ` - ${item.date_end}` : ''
      return `${name} (${type}) ${carrier} ${active} ${endDate}`
    },
    querySearch (queryString, cb) {
      this.isLoading = true
      this.$sdk.ratecard.list(builder => {
        builder.filters = { 'name': queryString }
        builder.include = [ 'carrier' ]
      }).then(res => {
        this.data = res
        this.isLoading = false
      })
    },
    getRateCardId () {
      return this.input
    },
    clearInput () {
      this.input = ''
      this.$emit('input', {})
    }
  }
}
</script>

<style>

</style>
